"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL = exports.LOAD_CONFIG = void 0;
const constants_1 = require("../../../core/script/constants");
exports.LOAD_CONFIG = { sync: constants_1.SyncConfig.ASYNC, order: constants_1.OrderConfig.TOP };
exports.URL = 'https://www.gstatic.com/charts/loader.js';
//# sourceMappingURL=constants.js.map